/**
 * @file Alert
 */

/**
 * Alert component
 */
const vAlert = () => {
    const alert = document.querySelector('.v-alert');

    if (!alert) {
        return;
    }

    const dropdown = alert.querySelector('.v-alert__dropdown');

    if (alert.classList.contains('v-alert--dynamic')) {
        /**
         * Mutation observer callback
         */
        const mutationCallback = (mutationsList, o) => {
            mutationsList.forEach((mutation) => {
                if (mutation.target.classList.contains('v-alert--visible')) {
                    setTimeout(() => {
                        mutation.target.classList.remove('v-alert--visible');
                        mutation.target.classList.add('v-alert--reverse');
                        setTimeout(() => {
                            mutation.target.classList.remove('v-alert--reverse');
                            mutation.target.classList.add('v-alert--hidden');
                        }, 750);
                    }, 1000);
                }
            });
        };

        const observer = new MutationObserver(mutationCallback);
        observer.observe(alert, {
            attributes: true,
            attributeFilter: ['class'],
        });

        if (alert.classList.contains('v-alert--visible')) {
            setTimeout(() => {
                alert.classList.remove('v-alert--visible');
                alert.classList.add('v-alert--reverse');
                setTimeout(() => {
                    alert.classList.remove('v-alert--reverse');
                    alert.classList.add('v-alert--hidden');
                }, 750);
            }, 1500);
        }
    }

    if (dropdown) {
        const trigger = dropdown.querySelector('.v-alert__dropdown-trigger');

        trigger.addEventListener('click', () => {
            if (dropdown.classList.contains('is-active')) {
                dropdown.classList.remove('is-active');
            } else {
                dropdown.classList.add('is-active');
            }
        });
    }
};

export default vAlert;
